import { useAuthStore } from '@/stores/authStore';
import { tryRestoreSessionFromRefreshCookie } from '@/lib/api';

let bootstrapPromise: Promise<void> | null = null;

/**
 * Один раз за жизнь страницы: дождаться гидрации persist, затем при отсутствии
 * access в sessionStorage попробовать POST /auth/refresh (httpOnly cookie).
 * Идемпотентно при StrictMode (двойной mount).
 */
export function runAuthSessionBootstrap(): Promise<void> {
  if (!bootstrapPromise) {
    bootstrapPromise = (async () => {
      if (!useAuthStore.persist.hasHydrated()) {
        await new Promise<void>((resolve) => {
          const unsub = useAuthStore.persist.onFinishHydration(() => {
            unsub();
            resolve();
          });
        });
      }

      const { accessToken, isAuthenticated } = useAuthStore.getState();
      if (accessToken && isAuthenticated) {
        return;
      }

      await tryRestoreSessionFromRefreshCookie();
    })();
  }
  return bootstrapPromise;
}
